import { reactive } from 'vue';

/* Global store */
const store = reactive({
	/* Whether the data has been loaded or not */
	ready: false,

	/* Full list of openings */
	postings: [],

	/* Available filter terms, keyed by the value used in selections */
	departments: {},
	locations: {},
	workplaceTypes: {},

	/* Current filters */
	filter: {
		departments: [],
		locations: [],
		workplaceTypes: [],
	},
});

export default store;
